import {
  Text,
  Heading,
  Modal,
  CloseButton,
  View,
  Spinner,
  Flex,
} from '@smarterservices/smarter-ui';
import { Button, SimpleSelect } from '@instructure/ui';
import useSessionStore from '../../stores/session';
import { useEffect, useState } from 'react';
import { getAvailableRoomsForTransfer } from '../../lib/api';

const TransferModal = () => {
  const {
    setTransferSessionSid,
    transferSessionSid,
    getSessionData,
    transferSession,
  } = useSessionStore();

  const [rooms, setRooms] = useState([]);
  const [session, setSession] = useState();
  const [roomsLoadingState, setRoomsLoadingState] = useState('loading');

  useEffect(() => {
    console.log('Load Rooms');
    setSession(getSessionData(transferSessionSid));
    // load the rooms that we can transfer to...
    const loadRooms = async () => {
      const rooms = await getAvailableRoomsForTransfer(transferSessionSid);

      if (rooms.successful) {
        setRooms(rooms);
        console.log(rooms);
        setRoomsLoadingState('loaded');
      } else {
        setRoomsLoadingState('error');
      }
    };
    loadRooms();
  }, []);

  const renderRoomOptions = () => {
    return rooms.map((room, index) => {
      return (
        <>
          <Text>
            Select the room you wish to transfer {session?.firstName}{' '}
            {session?.lastName} to.
          </Text>
          <SimpleSelect
            renderLabel="Available Rooms"
            assistiveText="Use arrow keys to navigate the room options."
            value="Room 1"
          >
            <SimpleSelect.Option key="{index}" id="{index}" value="Room 1">
              Room 1
            </SimpleSelect.Option>
          </SimpleSelect>
        </>
      );
    });
  };

  const renderNoRooms = () => {
    return <Text>There are no rooms available to transfer to.</Text>;
  };

  const renderErrorLoadingRooms = () => {
    return <Text>There was an error loading the rooms.</Text>;
  };

  const renderLoadingRooms = () => {
    return (
      <Flex alignItems="center" gap="small">
        <Spinner size="x-small" />
        <Text>Loading available rooms</Text>
      </Flex>
    );
  };

  return (
    <Modal
      open={transferSessionSid?.length}
      onDismiss={() => setTransferSessionSid(null)}
      label="Transfer Session"
      size="small"
    >
      <Modal.Header spacing="compact">
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => setTransferSessionSid(null)}
          screenReaderLabel="Close"
        />
        <Heading level="h3">Transfer Session</Heading>
      </Modal.Header>
      <Modal.Body>
        <View margin="medium none none none">
          {roomsLoadingState === 'loading' && renderLoadingRooms()}
          {roomsLoadingState === 'loaded' && renderRoomOptions()}
          {roomsLoadingState === 'error' && renderErrorLoadingRooms()}
          {roomsLoadingState === 'loaded' &&
            rooms.length === 0 &&
            renderNoRooms()}
        </View>
      </Modal.Body>
      {roomsLoadingState === 'loaded' && (
        <Modal.Footer>
          <Button onClick={() => transferSession()} color="primary">
            Confirm Transfer
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default TransferModal;
